import CriticalIllnessBenefitsSetIndex from './CriticalIllness/CriticalIllnessBenefitsSetIndex'
import CriticalIllnessBenefitsSetCreate from './CriticalIllness/CriticalIllnessBenefitsSetCreate'
import CriticalIllnessBenefitsSetShow from './CriticalIllness/CriticalIllnessBenefitsSetShow'
import CriticalIllnessBenefitsSetExportShow from './CriticalIllness/CriticalIllnessBenefitsSetExportShow'
import CriticalIllnessBenefitsSetEdit from './CriticalIllness/CriticalIllnessBenefitsSetEdit'
import CriticalIllnessBenefitsSetBulkEdit from './CriticalIllness/CriticalIllnessBenefitsSetBulkEditsComponent'
import CriticalIllnessBenefitsSetBulkIdentifier from './CriticalIllness/CriticalIllnessBenefitsSetBulkIdentifierComponent'
import HospitalIndemnityBenefitsSetIndex from './HospitalIndemnity/HospitalIndemnityBenefitsSetIndex'
import HospitalIndemnityBenefitsSetCreate from './HospitalIndemnity/HospitalIndemnityBenefitsSetCreate'
import HospitalIndemnityBenefitsSetShow from './HospitalIndemnity/HospitalIndemnityBenefitsSetShow'
import HospitalIndemnityBenefitsSetExportShow from './HospitalIndemnity/HospitalIndemnityBenefitsSetExportShow'
import HospitalIndemnityBenefitsSetEdit from './HospitalIndemnity/HospitalIndemnityBenefitsSetEdit'
import HospitalIndemnityBenefitsSetBulkEdit from './HospitalIndemnity/HospitalIndemnityBenefitsSetBulkEditsComponent'
import HospitalIndemnityBenefitsSetBulkIdentifier from './HospitalIndemnity/HospitalIndemnityBenefitsSetBulkIdentifierComponent'
import AccidentBenefitsSetIndex from './Accident/AccidentBenefitsSetIndex'
import AccidentBenefitsSetCreate from './Accident/AccidentBenefitsSetCreate'
import AccidentBenefitsSetShow from './Accident/AccidentBenefitsSetShow'
import AccidentBenefitsSetExportShow from './Accident/AccidentBenefitsSetExportShow'
import AccidentBenefitsSetEdit from './Accident/AccidentBenefitsSetEdit'
import AccidentBenefitsSetBulkEdit from './Accident/AccidentBenefitsSetBulkEditsComponent'
import AccidentBenefitsSetBulkIdentifier from './Accident/AccidentBenefitsSetBulkIdentifierComponent'
import MedicalBenefitsSetIndex from './Medical/MedicalBenefitsSetIndex'
import MedicalBenefitsSetShow from './Medical/MedicalBenefitsSetShow'
import MedicalBenefitsSetCreate from './Medical/MedicalBenefitsSetCreate'
import DentalBenefitsSetIndex from './Dental/DentalBenefitsSetIndex'
import DentalBenefitsSetCreate from './Dental/DentalBenefitsSetCreate'
import DentalBenefitsSetShow from './Dental/DentalBenefitsSetShow'
import DentalBenefitsSetExportShow from './Dental/DentalBenefitsSetExportShow'
import VisionBenefitsSetExportShow from './Vision/VisionBenefitsSetExportShow'
import MedicalBenefitsSetExportShow from './Medical/MedicalBenefitsSetExportShow'
import MedicareAdvantageBenefitsSetExportShow from './MedicareAdvantage/MedicareAdvantageBenefitsSetExportShow'
import DentalBenefitsSetEdit from './Dental/DentalBenefitsSetEdit'
import DentalBenefitsSetReview from './Dental/DentalBenefitsSetNewReview'
import VisionBenefitsSetIndex from './Vision/VisionBenefitsSetIndex'
import VisionBenefitsSetCreate from './Vision/VisionBenefitsSetCreate'
import VisionBenefitsSetShow from './Vision/VisionBenefitsSetShow'
import VisionBenefitsSetEdit from './Vision/VisionBenefitsSetEdit'
import VisionBenefitsSetReview from './Vision/VisionBenefitsSetNewReview'
import LevelFundedBenefitsSetIndex from './LevelFunded/LevelFundedBenefitsSetIndex'
import LevelFundedBenefitsSetCreate from './LevelFunded/LevelFundedBenefitsSetCreate'
import LevelFundedBenefitsSetShow from './LevelFunded/LevelFundedBenefitsSetShow'
import LevelFundedBenefitsSetBulkEdit from './LevelFunded/LevelFundedBenefitsSetBulkEditsComponent'
import LevelFundedBenefitsSetExportShow from './LevelFunded/LevelFundedBenefitsSetExportShow'
import LevelFundedBenefitsSetBulkIdentifier from './LevelFunded/LevelFundedBenefitsSetBulkIdentifierComponent'
import LevelFundedBusinessRulesShow from './LevelFunded/LevelFundedBusinessRulesShow'
import LevelFundedBenefitsSetEdit from './LevelFunded/LevelFundedBenefitsSetEdit'
import LargeGroupCustomBenefitsSetIndex from './LargeGroupCustom/LargeGroupCustomBenefitsSetIndex'
import LargeGroupCustomBenefitsSetCreate from './LargeGroupCustom/LargeGroupCustomBenefitsSetCreate'
import LargeGroupCustomBenefitsSetShow from './LargeGroupCustom/LargeGroupCustomBenefitsSetShow'
import LargeGroupCustomBenefitsSetBulkEdit from './LargeGroupCustom/LargeGroupCustomBenefitsSetBulkEditsComponent'
import LargeGroupCustomBenefitsSetExportShow from './LargeGroupCustom/LargeGroupCustomBenefitsSetExportShow'
import LargeGroupCustomBenefitsSetBulkIdentifier from './LargeGroupCustom/LargeGroupCustomBenefitsSetBulkIdentifierComponent'
import LargeGroupCustomBusinessRulesShow from './LargeGroupCustom/LargeGroupCustomBusinessRulesShow'
import LargeGroupCustomBenefitsSetEdit from './LargeGroupCustom/LargeGroupCustomBenefitsSetEdit'
import BenefitsSetEdit from './Medical/MedicalBenefitsSetEdit'
import BenefitsSetReview from './Medical/MedicalBenefitsSetNewReview'
import BenefitsSetExternalIdShow from './BenefitsSet/BenefitsSetExternalIdShow'
import MedicalBenefitsSetCopy from './Medical/MedicalBenefitsSetCopy'
import CarrierUserCreate from './CarrierUsers/CarrierUserCreate'
import CarrierUserEdit from './CarrierUsers/CarrierUserEdit'
import CarrierUserShow from './CarrierUsers/CarrierUserShow'
import CarrierUserIndex from './CarrierUsers/CarrierUserIndex'
import ScenariosContainer from './CarrierVerification/Scenarios'
import CensusCreate from './CarrierVerification/Censuses/CensusCreate'
import CensusEdit from './CarrierVerification/Censuses/CensusEdit'
import DocumentCreate from './Documents/DocumentCreate'
import DocumentEdit from './Documents/DocumentEdit'
import DocumentsIndex from './Documents/DocumentIndex'
import CarrierBrandsIndex from './CarrierBrands/CarrierBrandIndex'
import CarrierBrandsCreate from './CarrierBrands/CarrierBrandCreate'
import CarrierBrandsEdit from './CarrierBrands/CarrierBrandEdit'
import InternalUserCreate from './InternalUsers/InternalUserCreate'
import InternalUserEdit from './InternalUsers/InternalUserEdit'
import InternalUserShow from './InternalUsers/InternalUserShow'
import InternalUserIndex from './InternalUsers/InternalUserIndex'
import IssuerIndex from './Issuers/IssuerIndex'
import IssuerCreate from './Issuers/IssuerCreate'
import IssuerEdit from './Issuers/IssuerEdit'
import IssuerDisclaimerCreate from './IssuerDisclaimers/IssuerDisclaimerCreate'
import IssuerDisclaimerEdit from './IssuerDisclaimers/IssuerDisclaimerEdit'
import IssuerDisclaimerShow from './IssuerDisclaimers/IssuerDisclaimerShow'
import IssuerDisclaimerIndex from './IssuerDisclaimers/IssuerDisclaimerIndex'
import IssuerSourceCreate from './IssuerSources/IssuerSourceCreate'
import IssuerSourceEdit from './IssuerSources/IssuerSourceEdit'
import IssuerSourceIndex from './IssuerSources/IssuerSourceIndex'
import IssuerStatusCreate from './IssuerStatuses/IssuerStatusCreate'
import IssuerStatusEdit from './IssuerStatuses/IssuerStatusEdit'
import IssuerStatusIndex from './IssuerStatuses/IssuerStatusIndex'
import PrivateExchangeCreate from './PrivateExchanges/PrivateExchangeCreate'
import PrivateExchangeEdit from './PrivateExchanges/PrivateExchangeEdit'
import PrivateExchangeIndex from './PrivateExchanges/PrivateExchangeIndex'
import RatesBatchCreate from './RatesBatches/RatesBatchCreate'
import RatesBatchExport from './RatesBatches/RatesBatchExport'
import SharedBusinessRulesIndex from './SharedBusinessRules/SharedBusinessRulesIndex'
import SheetRateIndex from './SheetRates/SheetRateIndex'
import SheetRatesReview from './SheetRates/SheetRatesReview'
import SheetRatesBulkIdentifier from './SheetRates/SheetRatesBulkIdentifierComponent'
import EmbargoCreate from './Embargoes/EmbargoCreate'
import EmbargoShow from './Embargoes/EmbargoShow'
import EmbargoIndex from './Embargoes/EmbargoIndex'
import EmbargoEdit from './Embargoes/EmbargoEdit'
import MedicalBenefitsSetBulkEdit from './Medical/MedicalBenefitsSetBulkEditsComponent'
import MedicalBenefitsSetBulkIdentifier from './Medical/MedicalBenefitsSetBulkIdentifierComponent'
import MedicareAdvantageBenefitsSetBulkEdit from './MedicareAdvantage/MedicareAdvantageBenefitsSetBulkEditsComponent'
import MedicareAdvantageBenefitsSetBulkIdentifier from './MedicareAdvantage/MedicareAdvantageBenefitsSetBulkIdentifierComponent'
import DentalBenefitsSetBulkEdit from './Dental/DentalBenefitsSetBulkEditsComponent'
import DentalBenefitsSetBulkIdentifier from './Dental/DentalBenefitsSetBulkIdentifierComponent'
import VisionBenefitsSetBulkEdit from './Vision/VisionBenefitsSetBulkEditsComponent'
import VisionBenefitsSetBulkIdentifier from './Vision/VisionBenefitsSetBulkIdentifierComponent'
import PlanProductIndex from './PlanProducts/PlanProductIndex'
import IssuerPeriodAudienceIndex from './IssuerPeriodAudiences/IssuerPeriodAudienceIndex'
import MedicareAdvantageBenefitsSetIndex from './MedicareAdvantage/MedicareAdvantageBenefitsSetIndex'
import MedicareAdvantageBenefitsSetShow from './MedicareAdvantage/MedicareAdvantageBenefitsSetShow'
import MedicareAdvantageBenefitsSetEdit from './MedicareAdvantage/MedicareAdvantageBenefitsSetEdit'
import ServiceAreasImport from './VericredImport/ServiceAreasImport'
import PlanServiceAreasImport from './VericredImport/PlanServiceAreasImport'
import HowieGeographiesIndex from './HowieGeography/HowieGeographiesIndex'
import HowieGeographiesCreate from './HowieGeography/HowieGeographiesCreate'
import HowieGeographiesShow from './HowieGeography/HowieGeographiesShow'
import HowieServiceAreaIndex from './HowieServiceAreas/HowieServiceAreaIndex'
import HowieServiceAreaReview from './HowieServiceAreas/HowieServiceAreaReview'
import AncillaryServiceAreaIndex from './AncillaryServiceAreas/AncillaryServiceAreaIndex'
import AncillaryServiceAreaShow from './AncillaryServiceAreas/AncillaryServiceAreaShow'
import AncillaryRateFactorSetIndex from './AncillaryRateFactorSets/AncillaryRateFactorSetIndex'
import AncillaryRateFactorSetShow from './AncillaryRateFactorSets/AncillaryRateFactorSetShow'
import AncillaryRateFactorSetCreate from './AncillaryRateFactorSets/AncillaryRateFactorSetCreate'
import AncillaryRateFactorSetEdit from './AncillaryRateFactorSets/AncillaryRateFactorSetEdit'
import FormIndex from './Forms/FormIndex'
import FormCreate from './Forms/FormCreate'
import FormEdit from './Forms/FormEdit'
import SmokeCheckIndex from './SmokeChecks/SmokeCheckIndex'
import SmokeCheckShow from './SmokeChecks/SmokeCheckShow'
import LifeBenefitsSetIndex from './Life/LifeBenefitsSetIndex'
import LifeBenefitsSetCreate from './Life/LifeBenefitsSetCreate'
import LifeBenefitsSetShow from './Life/LifeBenefitsSetShow'
import LifeBenefitsSetExportShow from './Life/LifeBenefitsSetExportShow'
import LifeBenefitsSetEdit from './Life/LifeBenefitsSetEdit'
import LifeBenefitsSetBulkEdit from './Life/LifeBenefitsSetBulkEditsComponent'
import LifeBenefitsSetBulkIdentifier from './Life/LifeBenefitsSetBulkIdentifierComponent'
import DisabilityBenefitsSetIndex from './Disability/DisabilityBenefitsSetIndex'
import DisabilityBenefitsSetCreate from './Disability/DisabilityBenefitsSetCreate'
import DisabilityBenefitsSetShow from './Disability/DisabilityBenefitsSetShow'
import DisabilityBenefitsSetExportShow from './Disability/DisabilityBenefitsSetExportShow'
import DisabilityBenefitsSetEdit from './Disability/DisabilityBenefitsSetEdit'
import DisabilityBenefitsSetBulkEdit from './Disability/DisabilityBenefitsSetBulkEditsComponent'
import DisabilityBenefitsSetBulkIdentifier from './Disability/DisabilityBenefitsSetBulkIdentifierComponent'
import NetworkIndex from './Networks/NetworkIndex'
import SharedBusinessRuleNew from './SharedBusinessRules/SharedBusinessRuleNew'
import SharedBusinessRuleEdit from './SharedBusinessRules/SharedBusinessRuleEdit'
import AccidentBusinessRulesShow from './Accident/AccidentBusinessRulesShow'
import DentalBusinessRulesShow from './Dental/DentalBusinessRulesShow'
import DisabilityBusinessRulesShow from './Disability/DisabilityBusinessRulesShow'
import VisionBusinessRulesShow from './Vision/VisionBusinessRulesShow'
import MedicalBusinessRulesShow from './Medical/MedicalBusinessRulesShow'
import LifeBusinessRulesShow from './Life/LifeBusinessRulesShow'
import CriticalIllnessBusinessRulesShow from './CriticalIllness/CriticalIllnessBusinessRulesShow'
import HospitalIndemnityBusinessRulesShow from './HospitalIndemnity/HospitalIndemnityBusinessRulesShow'
import BenefitsSetCsvExportIndex from './BenefitsSetCsvExport/BenefitsSetCsvExportIndex'
import PlatformIndex from './Platforms/PlatformIndex'
import PlatformCreate from './Platforms/PlatformCreate'
import AdminToolRunIndex from './Admin/AdminToolRunIndex'
import AdminToolRunCreate from './Admin/AdminToolRunCreate'
import ConfigurationsIndex from './Configurations/ConfigurationsIndex'
import SbcConfigurationCreate from './Configurations/SbcConfigurationCreate'
import SbcConfigurationEdit from './Configurations/SbcConfigurationEdit'

export const menuSections = [
  {
    title: 'Benefits Sets',
    routes: [
      {
        title: 'New Benefits Set',
        path: '/medical_benefits/new',
        group: 'medical_benefits_sets',
        action: 'create',
        label: 'Medical Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/medical_benefits',
        group: 'medical_benefits_sets',
        action: 'index',
        label: 'Medical Benefits Sets'
      },
      {
        title: 'Copy Benefits Sets',
        path: '/medical_benefits/copy',
        group: 'medical_benefits_sets',
        action: 'create',
        label: 'Medical Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/level_funded_benefits/new',
        group: 'level_funded_benefits_sets',
        action: 'create',
        label: 'Level Funded Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/level_funded_benefits',
        group: 'level_funded_benefits_sets',
        action: 'index',
        label: 'Level Funded Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/dental_benefits/new',
        group: 'dental_benefits_sets',
        action: 'create',
        label: 'Dental Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/dental_benefits',
        group: 'dental_benefits_sets',
        action: 'index',
        label: 'Dental Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/vision_benefits/new',
        group: 'vision_benefits_sets',
        action: 'create',
        label: 'Vision Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/vision_benefits',
        group: 'vision_benefits_sets',
        action: 'index',
        label: 'Vision Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/med_adv_benefits',
        group: 'medicare_advantage_benefits_sets',
        action: 'index',
        label: 'Medicare Advantage Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/life_benefits/new',
        group: 'life_benefits_sets',
        action: 'create',
        label: 'Life Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/life_benefits',
        group: 'life_benefits_sets',
        action: 'index',
        label: 'Life Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/disability_benefits/new',
        group: 'disability_benefits_sets',
        action: 'create',
        label: 'Disability Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/disability_benefits',
        group: 'disability_benefits_sets',
        action: 'index',
        label: 'Disability Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/accident_benefits/new',
        group: 'accident_benefits_sets',
        action: 'create',
        label: 'Accident Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/accident_benefits',
        group: 'accident_benefits_sets',
        action: 'index',
        label: 'Accident Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/hospital_indemnity_benefits/new',
        group: 'generic_benefits_sets',
        action: 'create',
        label: 'Hospital Indemnity Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/hospital_indemnity_benefits',
        group: 'generic_benefits_sets',
        action: 'index',
        label: 'Hospital Indemnity Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/critical_illness_benefits/new',
        group: 'generic_benefits_sets',
        action: 'create',
        label: 'Critical Illness Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/critical_illness_benefits',
        group: 'generic_benefits_sets',
        action: 'index',
        label: 'Critical Illness Benefits Sets'
      },
      {
        title: 'New Benefits Set',
        path: '/large_group_custom_benefits/new',
        group: 'large_group_custom_benefits_sets',
        action: 'create',
        label: 'Large Group Custom Benefits Sets'
      },
      {
        title: 'All Benefits Sets',
        path: '/large_group_custom_benefits',
        group: 'large_group_custom_benefits_sets',
        action: 'index',
        label: 'Large Group Custom Benefits Sets'
      },
      {
        title: 'All Exports',
        path: '/benefits_set_csv_exports',
        group: 'benefits_set_csv_exports',
        action: 'index',
        label: 'CSV Exports'
      }
      // Insert new LOC (DO NOT DELETE)
    ]
  },
  {
    title: 'Rates',
    routes: [
      { title: 'Upload', path: '/rates_batches/new', group: 'rates_batches', action: 'create' },
      { title: 'All Rates', path: '/sheet_rates', group: 'sheet_rates', action: 'index' },
      { title: 'Ancillary Rate Factor Sets',
        path: '/ancillary_rate_factor_sets',
        group: 'ancillary_rate_factor_sets',
        action: 'index' },
      { title: 'Ancillary Plan Service Areas',
        path: '/ancillary_plan_service_areas/new',
        group: 'vericred_imports',
        action: 'create' }
    ]
  },
  {
    title: 'Service Areas',
    routes: [
      { title: 'All Service Areas', path: '/howie_service_areas', group: 'howie_service_areas', action: 'index' },
      { title: 'Geographies', path: '/howie_geographies', group: 'howie_geographies', action: 'index' },
      { title: 'Ancillary Service Areas',
        path: '/ancillary_service_areas',
        group: 'ancillary_service_areas',
        action: 'index' }
    ]
  },
  {
    title: 'Carrier Verification',
    routes: [
      { title: 'Censuses', path: '/censuses/new', group: 'censuses', action: 'create' },
      { title: 'Scenarios', path: '/scenarios', group: 'scenarios', action: 'create' }
    ]
  },
  {
    title: 'Carrier Organization',
    routes: [
      { title: 'Carrier Brands', path: '/carrier_brands', group: 'carrier_brands', action: 'index' },
      { title: 'Issuers', path: '/issuers', group: 'issuers', action: 'index' },
      { title: 'Issuer Statuses', path: '/issuer_statuses', group: 'issuer_statuses', action: 'index' },
      { title: 'Issuer Sources', path: '/issuer_sources', group: 'issuer_sources', action: 'index' },
      { title: 'Issuer Disclaimers', path: '/issuer_disclaimers', group: 'issuer_disclaimers', action: 'index' },
      { title: 'Private Exchanges', path: '/private_exchanges', group: 'private_exchanges', action: 'index' }
    ]
  },
  {
    title: 'Documents',
    routes: [
      { title: 'All Documents', path: '/documents', group: 'documents', action: 'index' },
      { title: 'New Document', path: '/documents/new', group: 'documents', action: 'create' }
    ]
  },
  {
    title: 'Embargoes',
    routes: [
      { title: 'Create Embargo', path: '/embargoes/new', group: 'embargoes', action: 'create' },
      { title: 'All Embargoes', path: '/embargoes', group: 'embargoes', action: 'index' }
    ]
  },
  {
    title: 'IPAs',
    routes: [
      { title: 'All IPAs', path: '/issuer_period_audiences', group: 'issuer_period_audiences', action: 'index' },
      { title: 'Smoke Checks', path: '/smoke_checks', group: 'smoke_checks', action: 'index' }
    ]
  },
  {
    title: 'Forms',
    routes: [
      { title: 'New Form', path: '/forms/new', group: 'forms', action: 'create' },
      { title: 'All Forms', path: '/forms', group: 'forms', action: 'index' }
    ]
  },
  {
    title: 'Networks',
    routes: [
      {
        title: 'All Networks',
        path: '/networks',
        group: 'networks',
        action: 'index'
      }
    ]
  },
  {
    title: 'Business Rules',
    routes: [
      { title: 'All Business Rules', path: '/business_rules', group: 'shared_business_rules', action: 'index' },
      {
        title: 'New Business Rule',
        path: '/business_rules/new',
        group: 'shared_business_rules',
        action: 'create'
      }
    ]
  },
  {
    title: 'Platforms',
    routes: [
      { title: 'All Platforms', path: '/platforms', group: 'platforms', action: 'index' },
      { title: 'New Platform', path: '/platforms/new', group: 'platforms', action: 'create' }
    ]
  },
  {
    title: 'Users',
    routes: [
      {
        title: 'Internal Users',
        path: '/internal_users',
        group: 'users',
        action: 'index',
        allowedRoles: ['administrator']
      },
      {
        title: 'New Internal User',
        path: '/internal_users/new',
        group: 'users',
        action: 'create',
        allowedRoles: ['administrator']
      },
      {
        title: 'Carrier Users',
        path: '/carrier_users',
        group: 'users',
        action: 'index',
        allowedRoles: ['carrier_qa', 'administrator']
      },
      {
        title: 'New Carrier User',
        path: '/carrier_users/new',
        group: 'users',
        action: 'create',
        allowedRoles: ['carrier_qa', 'administrator']
      }
    ]
  },
  {
    title: 'Admin',
    routes: [
      {
        title: 'Configurations',
        path: '/configurations',
        group: 'sbc_configurations',
        action: 'index'
      },
      {
        title: 'Admin Tool Logs',
        path: '/admin_tool_runs',
        group: 'admin_tool_runs',
        action: 'index'
      },
      {
        title: 'New Admin Tool Run',
        path: '/admin_tool_runs/new',
        group: 'admin_tool_runs',
        action: 'create'
      }
    ]
  }
]

export const routes = [
  {
    path: '/critical_illness_benefits',
    component: CriticalIllnessBenefitsSetIndex,
    group: 'generic_benefits_sets',
    action: 'index'
  },
  {
    path: '/critical_illness_benefits/new',
    component: CriticalIllnessBenefitsSetCreate,
    group: 'generic_benefits_sets',
    action: 'create'
  },
  {
    path: '/critical_illness_benefits/bulk/identifiers',
    component: CriticalIllnessBenefitsSetBulkIdentifier,
    group: 'generic_benefits_sets',
    action: 'index'
  },
  {
    path: '/critical_illness_benefits/bulk',
    component: CriticalIllnessBenefitsSetBulkEdit,
    group: 'generic_benefits_sets',
    action: 'update'
  },
  {
    path: '/critical_illness_benefits/:id',
    component: CriticalIllnessBenefitsSetShow,
    group: 'generic_benefits_sets',
    action: 'show'
  },
  {
    path: '/critical_illness_benefits/:id/business_rules',
    component: CriticalIllnessBusinessRulesShow,
    group: 'generic_benefits_sets',
    action: 'show'
  },
  {
    path: '/critical_illness_benefits/:id/edit',
    component: CriticalIllnessBenefitsSetEdit,
    group: 'generic_benefits_sets',
    action: 'update'
  },
  {
    path: '/critical_illness_benefits_exports/:id',
    component: CriticalIllnessBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/hospital_indemnity_benefits',
    component: HospitalIndemnityBenefitsSetIndex,
    group: 'generic_benefits_sets',
    action: 'index'
  },
  {
    path: '/hospital_indemnity_benefits/new',
    component: HospitalIndemnityBenefitsSetCreate,
    group: 'generic_benefits_sets',
    action: 'create'
  },
  {
    path: '/hospital_indemnity_benefits/bulk/identifiers',
    component: HospitalIndemnityBenefitsSetBulkIdentifier,
    group: 'generic_benefits_sets',
    action: 'index'
  },
  {
    path: '/hospital_indemnity_benefits/bulk',
    component: HospitalIndemnityBenefitsSetBulkEdit,
    group: 'generic_benefits_sets',
    action: 'update'
  },
  {
    path: '/hospital_indemnity_benefits/new',
    component: HospitalIndemnityBenefitsSetCreate,
    group: 'generic_benefits_sets',
    action: 'create'
  },
  {
    path: '/hospital_indemnity_benefits/:id',
    component: HospitalIndemnityBenefitsSetShow,
    group: 'generic_benefits_sets',
    action: 'show'
  },
  {
    path: '/hospital_indemnity_benefits/:id/business_rules',
    component: HospitalIndemnityBusinessRulesShow,
    group: 'generic_benefits_sets',
    action: 'show'
  },
  {
    path: '/hospital_indemnity_benefits/:id/edit',
    component: HospitalIndemnityBenefitsSetEdit,
    group: 'generic_benefits_sets',
    action: 'update'
  },
  {
    path: '/hospital_indemnity_benefits_exports/:id',
    component: HospitalIndemnityBenefitsSetExportShow,
    group: 'generic_benefits_sets',
    action: 'show'
  },
  {
    path: '/accident_benefits',
    component: AccidentBenefitsSetIndex,
    group: 'accident_benefits_sets',
    action: 'index'
  },
  {
    path: '/accident_benefits/new',
    component: AccidentBenefitsSetCreate,
    group: 'accident_benefits_sets',
    action: 'create'
  },
  {
    path: '/accident_benefits/bulk/identifiers',
    component: AccidentBenefitsSetBulkIdentifier,
    group: 'accident_benefits_sets',
    action: 'index'
  },
  {
    path: '/accident_benefits/bulk',
    component: AccidentBenefitsSetBulkEdit,
    group: 'accident_benefits_sets',
    action: 'update'
  },
  {
    path: '/accident_benefits/new',
    component: AccidentBenefitsSetCreate,
    group: 'accident_benefits_sets',
    action: 'create'
  },
  {
    path: '/accident_benefits/:id',
    component: AccidentBenefitsSetShow,
    group: 'accident_benefits_sets',
    action: 'show'
  },
  {
    path: '/accident_benefits/:id/business_rules',
    component: AccidentBusinessRulesShow,
    group: 'accident_benefits_sets',
    action: 'show'
  },
  {
    path: '/accident_benefits/:id/edit',
    component: AccidentBenefitsSetEdit,
    group: 'accident_benefits_sets',
    action: 'update'
  },
  {
    path: '/accident_benefits_exports/:id',
    component: AccidentBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/medical_benefits',
    component: MedicalBenefitsSetIndex,
    group: 'medical_benefits_sets',
    action: 'index'
  },
  {
    path: '/rates_batches/new',
    component: RatesBatchCreate,
    group: 'rates_batches',
    action: 'create'
  },
  {
    path: '/rates_batches_export/:id',
    component: RatesBatchExport,
    group: 'rates_batches',
    action: 'show'
  },
  {
    path: '/dental_benefits',
    component: DentalBenefitsSetIndex,
    group: 'dental_benefits_sets',
    action: 'index'
  },
  {
    path: '/medical_benefits/new',
    component: MedicalBenefitsSetCreate,
    group: 'medical_benefits_sets',
    action: 'create'
  },
  {
    path: '/medical_benefits/bulk/identifiers',
    component: MedicalBenefitsSetBulkIdentifier,
    group: 'medical_benefits_sets',
    action: 'index'
  },
  {
    path: '/medical_benefits/bulk',
    component: MedicalBenefitsSetBulkEdit,
    group: 'medical_benefits_sets',
    action: 'update'
  },
  {
    path: '/medical_benefits/copy',
    component: MedicalBenefitsSetCopy,
    group: 'medical_benefits_sets',
    action: 'create'
  },
  {
    path: '/level_funded_benefits',
    component: LevelFundedBenefitsSetIndex,
    group: 'level_funded_benefits_sets',
    action: 'index'
  },
  {
    path: '/level_funded_benefits/new',
    component: LevelFundedBenefitsSetCreate,
    group: 'level_funded_benefits_sets',
    action: 'create'
  },
  {
    path: '/level_funded_benefits/bulk/identifiers',
    component: LevelFundedBenefitsSetBulkIdentifier,
    group: 'level_funded_benefits_sets',
    action: 'index'
  },
  {
    path: '/level_funded_benefits_exports/:id',
    component: LevelFundedBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/level_funded_benefits/bulk',
    component: LevelFundedBenefitsSetBulkEdit,
    group: 'level_funded_benefits_sets',
    action: 'update'
  },
  {
    path: '/level_funded_benefits/:id/business_rules',
    component: LevelFundedBusinessRulesShow,
    group: 'level_funded_benefits_sets',
    action: 'show'
  },
  {
    path: '/level_funded_benefits/:id',
    component: LevelFundedBenefitsSetShow,
    group: 'level_funded_benefits_sets',
    action: 'show'
  },
  {
    path: '/level_funded_benefits/:id/edit',
    component: LevelFundedBenefitsSetEdit,
    group: 'level_funded_benefits_sets',
    action: 'update'
  },
  {
    path: '/large_group_custom_benefits',
    component: LargeGroupCustomBenefitsSetIndex,
    group: 'large_group_custom_benefits_sets',
    action: 'index'
  },
  {
    path: '/large_group_custom_benefits/new',
    component: LargeGroupCustomBenefitsSetCreate,
    group: 'large_group_custom_benefits_sets',
    action: 'create'
  },
  {
    path: '/large_group_custom_benefits/bulk/identifiers',
    component: LargeGroupCustomBenefitsSetBulkIdentifier,
    group: 'large_group_custom_benefits_sets',
    action: 'index'
  },
  {
    path: '/large_group_custom_benefits_exports/:id',
    component: LargeGroupCustomBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/large_group_custom_benefits/bulk',
    component: LargeGroupCustomBenefitsSetBulkEdit,
    group: 'large_group_custom_benefits_sets',
    action: 'update'
  },
  {
    path: '/large_group_custom_benefits/:id/business_rules',
    component: LargeGroupCustomBusinessRulesShow,
    group: 'large_group_custom_benefits_sets',
    action: 'show'
  },
  {
    path: '/large_group_custom_benefits/:id',
    component: LargeGroupCustomBenefitsSetShow,
    group: 'large_group_custom_benefits_sets',
    action: 'show'
  },
  {
    path: '/large_group_custom_benefits/:id/edit',
    component: LargeGroupCustomBenefitsSetEdit,
    group: 'large_group_custom_benefits_sets',
    action: 'update'
  },
  {
    path: '/dental_benefits/new',
    component: DentalBenefitsSetCreate,
    group: 'dental_benefits_sets',
    action: 'create'
  },
  {
    path: '/dental_benefits/bulk/identifiers',
    component: DentalBenefitsSetBulkIdentifier,
    group: 'dental_benefits_sets',
    action: 'index'
  },
  {
    path: '/dental_benefits/bulk',
    component: DentalBenefitsSetBulkEdit,
    group: 'dental_benefits_sets',
    action: 'update'
  },
  {
    path: '/dental_benefits/:id',
    component: DentalBenefitsSetShow,
    group: 'dental_benefits_sets',
    action: 'show'
  },
  {
    path: '/dental_benefits/:id/business_rules',
    component: DentalBusinessRulesShow,
    group: 'dental_benefits_sets',
    action: 'show'
  },
  {
    path: '/dental_benefits/:id/edit',
    component: DentalBenefitsSetEdit,
    group: 'dental_benefits_sets',
    action: 'update'
  },
  {
    path: '/life_benefits',
    component: LifeBenefitsSetIndex,
    group: 'life_benefits_sets',
    action: 'index'
  },
  {
    path: '/life_benefits/new',
    component: LifeBenefitsSetCreate,
    group: 'life_benefits_sets',
    action: 'create'
  },
  {
    path: '/life_benefits/bulk/identifiers',
    component: LifeBenefitsSetBulkIdentifier,
    group: 'life_benefits_sets',
    action: 'index'
  },
  {
    path: '/life_benefits/bulk',
    component: LifeBenefitsSetBulkEdit,
    group: 'life_benefits_sets',
    action: 'update'
  },
  {
    path: '/life_benefits/:id',
    component: LifeBenefitsSetShow,
    group: 'life_benefits_sets',
    action: 'show'
  },
  {
    path: '/life_benefits/:id/business_rules',
    component: LifeBusinessRulesShow,
    group: 'life_benefits_sets',
    action: 'show'
  },
  {
    path: '/life_benefits/:id/edit',
    component: LifeBenefitsSetEdit,
    group: 'life_benefits_sets',
    action: 'update'
  },
  {
    path: '/life_benefits_exports/:id',
    component: LifeBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/disability_benefits',
    component: DisabilityBenefitsSetIndex,
    group: 'disability_benefits_sets',
    action: 'index'
  },
  {
    path: '/disability_benefits/new',
    component: DisabilityBenefitsSetCreate,
    group: 'disability_benefits_sets',
    action: 'create'
  },
  {
    path: '/disability_benefits/bulk/identifiers',
    component: DisabilityBenefitsSetBulkIdentifier,
    group: 'disability_benefits_sets',
    action: 'index'
  },
  {
    path: '/disability_benefits/bulk',
    component: DisabilityBenefitsSetBulkEdit,
    group: 'disability_benefits_sets',
    action: 'update'
  },
  {
    path: '/disability_benefits/new',
    component: DisabilityBenefitsSetCreate,
    group: 'disability_benefits_sets',
    action: 'create'
  },
  {
    path: '/disability_benefits/:id',
    component: DisabilityBenefitsSetShow,
    group: 'disability_benefits_sets',
    action: 'show'
  },
  {
    path: '/disability_benefits/:id/business_rules',
    component: DisabilityBusinessRulesShow,
    group: 'disability_benefits_sets',
    action: 'show'
  },
  {
    path: '/disability_benefits/:id/edit',
    component: DisabilityBenefitsSetEdit,
    group: 'disability_benefits_sets',
    action: 'update'
  },
  {
    path: '/disability_benefits_exports/:id',
    component: DisabilityBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/medical_benefits/:id',
    component: MedicalBenefitsSetShow,
    group: 'medical_benefits_sets',
    action: 'show'
  },
  {
    path: '/plan_external_ids/:id',
    component: BenefitsSetExternalIdShow,
    group: 'medical_benefits_sets',
    action: 'show'
  },
  {
    path: '/medical_benefits/:id/business_rules',
    component: MedicalBusinessRulesShow,
    group: 'medical_benefits_sets',
    action: 'show'
  },
  {
    path: '/medical_benefits/:id/edit',
    component: BenefitsSetEdit,
    group: 'medical_benefits_sets',
    action: 'update'
  },
  {
    path: '/medical_benefits/:id/reviews/new',
    component: BenefitsSetReview,
    group: 'medical_benefits_set_reviews',
    action: 'create'
  },
  {
    path: '/dental_benefits/:id/reviews/new',
    component: DentalBenefitsSetReview,
    group: 'dental_benefits_set_reviews',
    action: 'create'
  },
  {
    path: '/vision_benefits/:id/reviews/new',
    component: VisionBenefitsSetReview,
    group: 'vision_benefits_set_reviews',
    action: 'create'
  },
  {
    path: '/vision_benefits',
    component: VisionBenefitsSetIndex,
    group: 'vision_benefits_sets',
    action: 'index'
  },
  {
    path: '/vision_benefits/new',
    component: VisionBenefitsSetCreate,
    group: 'vision_benefits_sets',
    action: 'create'
  },
  {
    path: '/dental_benefits_exports/:id',
    component: DentalBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/vision_benefits/bulk/identifiers',
    component: VisionBenefitsSetBulkIdentifier,
    group: 'vision_benefits_sets',
    action: 'index'
  },
  {
    path: '/vision_benefits/bulk',
    component: VisionBenefitsSetBulkEdit,
    group: 'vision_benefits_sets',
    action: 'update'
  },
  {
    path: '/vision_benefits_exports/:id',
    component: VisionBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/medical_benefits_exports/:id',
    component: MedicalBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/vision_benefits/:id',
    component: VisionBenefitsSetShow,
    group: 'vision_benefits_sets',
    action: 'show'
  },
  {
    path: '/vision_benefits/:id/business_rules',
    component: VisionBusinessRulesShow,
    group: 'vision_benefits_sets',
    action: 'show'
  },
  {
    path: '/vision_benefits/:id/edit',
    component: VisionBenefitsSetEdit,
    group: 'vision_benefits_sets',
    action: 'update'
  },
  {
    path: '/med_adv_benefits/bulk/identifiers',
    component: MedicareAdvantageBenefitsSetBulkIdentifier,
    group: 'medicare_advantage_benefits_sets',
    action: 'index'
  },
  {
    path: '/med_adv_benefits/bulk',
    component: MedicareAdvantageBenefitsSetBulkEdit,
    group: 'medicare_advantage_benefits_sets',
    action: 'update'
  },
  {
    path: '/med_adv_benefits',
    component: MedicareAdvantageBenefitsSetIndex,
    group: 'medicare_advantage_benefits_sets',
    action: 'index'
  },
  {
    path: '/med_adv_benefits/:id',
    component: MedicareAdvantageBenefitsSetShow,
    group: 'medicare_advantage_benefits_sets',
    action: 'show'
  },
  {
    path: '/med_adv_benefits/:id/edit',
    component: MedicareAdvantageBenefitsSetEdit,
    group: 'medicare_advantage_benefits_sets',
    action: 'update'
  },
  {
    path: '/med_adv_benefits_exports/:id',
    component: MedicareAdvantageBenefitsSetExportShow,
    group: 'benefits_sets_exports',
    action: 'show'
  },
  {
    path: '/benefits_set_csv_exports',
    component: BenefitsSetCsvExportIndex,
    group: 'benefits_set_csv_exports',
    action: 'index'
  },
  {
    path: '/documents/new',
    component: DocumentCreate,
    group: 'documents',
    action: 'create'
  },
  {
    path: '/documents/:id/edit',
    component: DocumentEdit,
    group: 'documents',
    action: 'update'
  },
  {
    path: '/documents',
    component: DocumentsIndex,
    group: 'documents',
    action: 'index'
  },
  {
    path: '/internal_users',
    component: InternalUserIndex,
    group: 'users',
    action: 'index'
  },
  {
    path: '/internal_users/new',
    component: InternalUserCreate,
    group: 'users',
    action: 'create'
  },
  {
    path: '/internal_users/:id/edit',
    component: InternalUserEdit,
    group: 'users',
    action: 'update'
  },
  {
    path: '/internal_users/:id',
    component: InternalUserShow,
    group: 'users',
    action: 'show'
  },
  {
    path: '/carrier_users',
    component: CarrierUserIndex,
    group: 'users',
    action: 'index'
  },
  {
    path: '/carrier_users/new',
    component: CarrierUserCreate,
    group: 'users',
    action: 'create'
  },
  {
    path: '/carrier_users/:id/edit',
    component: CarrierUserEdit,
    group: 'users',
    action: 'update'
  },
  {
    path: '/carrier_users/:id',
    component: CarrierUserShow,
    group: 'users',
    action: 'show'
  },
  {
    path: '/carrier_brands/new',
    component: CarrierBrandsCreate,
    group: 'carrier_brands',
    action: 'create'
  },
  {
    path: '/carrier_brands/:id/edit',
    component: CarrierBrandsEdit,
    group: 'carrier_brands',
    action: 'update'
  },
  {
    path: '/carrier_brands',
    component: CarrierBrandsIndex,
    group: 'carrier_brands',
    action: 'index'
  },
  {
    path: '/issuers/new',
    component: IssuerCreate,
    group: 'issuers',
    action: 'create'
  },
  {
    path: '/issuers/:id/edit',
    component: IssuerEdit,
    group: 'issuers',
    action: 'update'
  },
  {
    path: '/issuers',
    component: IssuerIndex,
    group: 'issuers',
    action: 'index'
  },
  {
    path: '/issuer_disclaimers/new',
    component: IssuerDisclaimerCreate,
    group: 'issuer_disclaimers',
    action: 'create'
  },
  {
    path: '/issuer_disclaimers/:id/edit',
    component: IssuerDisclaimerEdit,
    group: 'issuer_disclaimers',
    action: 'update'
  },
  {
    path: '/issuer_disclaimers/:id',
    component: IssuerDisclaimerShow,
    group: 'issuer_disclaimers',
    action: 'show'
  },
  {
    path: '/issuer_disclaimers',
    component: IssuerDisclaimerIndex,
    group: 'issuer_disclaimers',
    action: 'index'
  },
  {
    path: '/issuer_sources/new',
    component: IssuerSourceCreate,
    group: 'issuer_sources',
    action: 'create'
  },
  {
    path: '/issuer_sources',
    component: IssuerSourceIndex,
    group: 'issuer_sources',
    action: 'index'
  },
  {
    path: '/issuer_sources/:id/edit',
    component: IssuerSourceEdit,
    group: 'issuer_sources',
    action: 'update'
  },
  {
    path: '/issuer_statuses/new',
    component: IssuerStatusCreate,
    group: 'issuer_statuses',
    action: 'create'
  },
  {
    path: '/issuer_statuses',
    component: IssuerStatusIndex,
    group: 'issuer_statuses',
    action: 'index'
  },
  {
    path: '/issuer_statuses/:id/edit',
    component: IssuerStatusEdit,
    group: 'issuer_statuses',
    action: 'update'
  },
  {
    path: '/private_exchanges/new',
    component: PrivateExchangeCreate,
    group: 'private_exchanges',
    action: 'create'
  },
  {
    path: '/private_exchanges',
    component: PrivateExchangeIndex,
    group: 'private_exchanges',
    action: 'index'
  },
  {
    path: '/private_exchanges/:id/edit',
    component: PrivateExchangeEdit,
    group: 'private_exchanges',
    action: 'update'
  },
  {
    path: '/censuses/:id/edit',
    component: CensusEdit,
    group: 'censuses',
    action: 'update'
  },
  {
    path: '/censuses/new',
    component: CensusCreate,
    group: 'censuses',
    action: 'create'
  },
  {
    path: '/scenarios',
    component: ScenariosContainer,
    group: 'scenarios',
    action: 'create'
  },
  {
    path: '/sheet_rates',
    component: SheetRateIndex,
    group: 'sheet_rates',
    action: 'index'
  },
  {
    path: '/sheet_rates/bulk/identifiers',
    component: SheetRatesBulkIdentifier,
    group: 'sheet_rates',
    action: 'index'
  },
  {
    path: '/sheet_rates/review',
    component: SheetRatesReview,
    group: 'sheet_rates',
    action: 'update'
  },
  {
    path: '/embargoes/new',
    component: EmbargoCreate,
    group: 'embargoes',
    action: 'create'
  },
  {
    path: '/embargoes/:id',
    component: EmbargoShow,
    group: 'embargoes',
    action: 'show'
  },
  {
    path: '/embargoes/:id/edit',
    component: EmbargoEdit,
    group: 'embargoes',
    action: 'update'
  },
  {
    path: '/embargoes',
    component: EmbargoIndex,
    group: 'embargoes',
    action: 'index'
  },
  {
    path: '/plan_products',
    component: PlanProductIndex,
    group: 'plan_products',
    action: 'index'
  },
  {
    path: '/issuer_period_audiences',
    component: IssuerPeriodAudienceIndex,
    group: 'issuer_period_audiences',
    action: 'index'
  },
  {
    path: '/ancillary_service_areas/new',
    component: ServiceAreasImport,
    group: 'vericred_imports',
    action: 'create'
  },
  {
    path: '/ancillary_plan_service_areas/new',
    component: PlanServiceAreasImport,
    group: 'vericred_imports',
    action: 'create'

  },
  {
    path: '/howie_geographies',
    component: HowieGeographiesIndex,
    group: 'howie_geographies',
    action: 'index'
  },
  {
    path: '/howie_geographies/new',
    component: HowieGeographiesCreate,
    group: 'howie_geographies',
    action: 'create'
  },
  {
    path: '/howie_geographies/:id',
    component: HowieGeographiesShow,
    group: 'howie_geographies',
    action: 'show'
  },
  {
    path: '/howie_service_areas',
    component: HowieServiceAreaIndex,
    group: 'howie_service_areas',
    action: 'index'
  },
  {
    path: '/howie_service_areas/:id/reviews/new',
    component: HowieServiceAreaReview,
    group: 'howie_service_area_reviews',
    action: 'create'
  },
  {
    path: '/ancillary_service_areas',
    component: AncillaryServiceAreaIndex,
    group: 'ancillary_service_areas',
    action: 'index'
  },
  {
    path: '/ancillary_service_areas/:id',
    component: AncillaryServiceAreaShow,
    group: 'ancillary_service_areas',
    action: 'show'
  },
  {
    path: '/ancillary_rate_factor_sets',
    component: AncillaryRateFactorSetIndex,
    group: 'ancillary_rate_factor_sets',
    action: 'index'
  },
  {
    path: '/ancillary_rate_factor_sets/new',
    component: AncillaryRateFactorSetCreate,
    group: 'ancillary_rate_factor_sets',
    action: 'create'
  },
  {
    path: '/ancillary_rate_factor_sets/:id',
    component: AncillaryRateFactorSetShow,
    group: 'ancillary_rate_factor_sets',
    action: 'show'
  },
  {
    path: '/ancillary_rate_factor_sets/:id/edit',
    component: AncillaryRateFactorSetEdit,
    group: 'ancillary_rate_factor_sets',
    action: 'update'
  },
  {
    path: '/forms/new',
    component: FormCreate,
    group: 'forms',
    action: 'create'
  },
  {
    path: '/forms',
    component: FormIndex,
    group: 'forms',
    action: 'index'
  },
  {
    path: '/forms/:id/edit',
    component: FormEdit,
    group: 'forms',
    action: 'update'
  },
  {
    path: '/smoke_checks',
    component: SmokeCheckIndex,
    group: 'smoke_checks',
    action: 'index'
  },
  {
    path: '/smoke_checks/:id',
    component: SmokeCheckShow,
    group: 'smoke_checks',
    action: 'show'
  },
  {
    path: '/networks',
    component: NetworkIndex,
    group: 'networks',
    action: 'index'
  },
  {
    path: '/business_rules',
    component: SharedBusinessRulesIndex,
    group: 'shared_business_rules',
    action: 'index'
  },
  {
    path: '/business_rules/new',
    component: SharedBusinessRuleNew,
    group: 'shared_business_rules',
    action: 'create'
  },
  {
    path: '/business_rules/:id/edit',
    component: SharedBusinessRuleEdit,
    group: 'shared_business_rules',
    action: 'update'
  },
  {
    path: '/platforms',
    component: PlatformIndex,
    group: 'platforms',
    action: 'index'
  },
  {
    path: '/platforms/new',
    component: PlatformCreate,
    group: 'platforms',
    action: 'create'
  },
  {
    path: '/admin_tool_runs',
    component: AdminToolRunIndex,
    group: 'admin_tool_runs',
    action: 'index'
  },
  {
    path: '/admin_tool_runs/new',
    component: AdminToolRunCreate,
    group: 'admin_tool_runs',
    action: 'create'
  },
  {
    path: '/configurations',
    component: ConfigurationsIndex,
    group: 'sbc_configurations',
    action: 'index'
  },
  {
    path: '/configurations/sbc',
    component: ConfigurationsIndex,
    group: 'sbc_configurations',
    action: 'index'
  },
  {
    path: '/configurations/sbc/new',
    component: SbcConfigurationCreate,
    group: 'sbc_configurations',
    action: 'create'
  },
  {
    path: '/configurations/sbc/:id/edit',
    component: SbcConfigurationEdit,
    group: 'sbc_configurations',
    action: 'update'
  }
]
